module.exports = __webpack_public_path__ + "img/15.2847aac0.png";